import React from 'react';
import { Mail } from 'react-feather';
import { Trans, useTranslation } from 'react-i18next';

import styles from '../Signup.module.css';

interface Step3Props {
  email: string;
  onResend: () => void;
  userExist: boolean;
}

function Step3({ email, onResend, userExist }: Step3Props) {
  const { t } = useTranslation();

  return (
    <div className={styles.signupInfo}>
      <Mail color="black" className={styles.signupBottomSpacing} />

      <h3 className={`${styles.signupTitle} ${styles.mb16}`}>{t('signup.step3.title')}</h3>
      <p className={styles.signupConfirm}>
        {userExist ? (
          <Trans
            className={styles.loginInfoSubtitle}
            i18nKey="signup.step3.userExist"
            components={{
              1: <b />
            }}
            values={{ email }}
          />
        ) : (
          t('signup.step3.message')
        )}
      </p>
      <span className={styles.signupFooter}>
        <Trans
          i18nKey="signup.step3.info"
          components={{
            1: <span onClick={onResend} />
          }}
        />
      </span>
    </div>
  );
}

export default Step3;
